<template>
  <b-navbar class="minimal-nav d-flex justify-content-center align-items-center" v-if="company">
    <b-navbar-brand class="m-0" :to="{ name: 'Dashboard' }">
      <img v-if="companyLogo" :src="companyLogo"/>
      <h2 v-else>{{ companyName }}</h2>
    </b-navbar-brand>
  </b-navbar>
</template>

<script>
import { mapRoot } from '@src/mixins/root';

export default {
  computed: {
    ...mapRoot([ 'company' ]),
    companyLogo() {
      const { company } = this;
      return company && company.siteBranding && company.siteBranding.bigLogo ? company.siteBranding.bigLogo.fileLocation : null;
    },
    companyName() {
      const { company } = this;
      return company && company.siteBranding && company.siteBranding.name ? company.siteBranding.name : company.name;
    },
  },
};
</script>

<style lang="scss">
.navbar.minimal-nav {
  img {
    max-height: 150px;
    max-width: 200px;
    object-fit: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header-minimal.vue